import { ArrayField, SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

// Only the keys the journal API itself models are declared here. Its order
// schema (charcuterie OrderDeSer / OrderLegDeSer) drops anything else on parse,
// so a wider model would write keys that are never stored or read back.
export class JournalOrderLeg {
  symbol = ""
  instrumentType = ""
  action = ""
  quantity = ""
}

export class JournalOrder {
  id = ""
  timeInForce = ""
  orderType = ""
  limitPrice = NaN
  status = ""
  cancelledAt: Date | null = null
  receivedAt: Date | null = null
  underlyingSymbol = ""
  legs: JournalOrderLeg[] = []
}

const hasLegs = (order: JournalOrder): boolean => order.legs.length > 0

export const JOURNAL_ORDER_LEG_DESER: SchemaDeSer<JournalOrderLeg> =
  new SchemaDeSerBuilder(JournalOrderLeg)
    .ofStrings("symbol", "instrumentType", "action", "quantity")
    .toDeSer()

export const JOURNAL_ORDER_DESER: SchemaDeSer<JournalOrder> =
  new SchemaDeSerBuilder(JournalOrder)
    .ofStrings("id", "timeInForce", "orderType", "status")
    .ofUnquotedFloat("limitPrice", "price")
    .ofDateTime("cancelledAt")
    .ofDateTime("receivedAt")
    // The Java guards legs before writing them, so an ungated field would put
    // an empty array on the wire that TwJournalEntrySerializer omits entirely.
    .addWhen(
      hasLegs,
      new ArrayField("legs", JOURNAL_ORDER_LEG_DESER, JournalOrderLeg)
    )
    .ofNullableString("underlyingSymbol")
    .toDeSer()
